import { render, staticRenderFns } from "./incomeEnsure.vue?vue&type=template&id=4ef98d16"
import script from "./incomeEnsure.vue?vue&type=script&lang=js"
export * from "./incomeEnsure.vue?vue&type=script&lang=js"
import style0 from "./incomeEnsure.vue?vue&type=style&index=0&id=4ef98d16&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports